<form [formGroup]="cedForm" (ngSubmit)="addCed()">
  <div class="form-container">
    <div class="form-field">
      <label>{{ 'referentiels.list.cedProperties.code.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="code" />
      <small class="p-error block">
        @if (cedForm.controls.code.errors?.required) {
          <p-message *ngIf="cedForm.controls['code'].invalid && cedForm.controls['code'].touched" severity="danger" text="Le code est requis."></p-message>
        } @else if (cedForm.controls.code.errors?.maxlength) {
          <p-message *ngIf="cedForm.controls['code'].invalid && cedForm.controls['code'].touched" severity="danger" text="Le code ne doit pas dépasser 6 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.cedProperties.danger.header'| transloco }}<span class="required">*</span></label>
      <p-checkbox formControlName="danger" binary="true" />
      <small class="p-error block">
        <p-message *ngIf="cedForm.controls['danger'].invalid && cedForm.controls['danger'].touched" severity="danger" text="Le champ danger est requis."></p-message>
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.cedProperties.libelle.header'| transloco }}<span class="required">*</span></label>
      <input pInputText formControlName="libelle" />
      <small class="p-error block">
        @if (cedForm.controls.libelle.errors?.required) {
          <p-message *ngIf="cedForm.controls['libelle'].invalid && cedForm.controls['libelle'].touched" severity="danger" text="Le libelle est requis."></p-message>
        } @else if (cedForm.controls.libelle.errors?.maxlength) {
          <p-message *ngIf="cedForm.controls['libelle'].invalid && cedForm.controls['libelle'].touched" severity="danger" text="Le libelle ne doit pas dépasser 250 caractères."></p-message>
        }
      </small>
    </div>

    <div class="form-field">
      <label>{{ 'referentiels.list.cedProperties.niveauCed.header'| transloco }}<span class="required">*</span></label>
      <p-dropdown formControlName="niveauCED" [options]="niveauCedOptions" placeholder="-- sélectionner --"> </p-dropdown>
      <small class="p-error block">
        <p-message *ngIf="cedForm.controls['niveauCED'].invalid && cedForm.controls['niveauCED'].touched" severity="danger" text="Le champ niveau CED est requis."></p-message>
      </small>
    </div>
  </div>

  <div class="button-container">
    <p-button [rounded]="true" pRipple label="{{ 'button.cancel' | transloco }}" (onClick)="close(false)" />
    <p-button [rounded]="true" type="submit" [disabled]="cedForm.invalid" pRipple label="{{ 'button.validate' | transloco }}" />
  </div>

  <div *ngIf="submitting" class="loading-spinner">
    <p-progressSpinner [style]="{ width: '3rem', height: '3rem' }"></p-progressSpinner>
  </div>
</form>
